/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { User } from './user';

export type GenericApiResponseListUserData = User[] | null;
